// extracted by mini-css-extract-plugin
module.exports = {"w17hqpjd":"w17hqpjd","inl2f0j":"inl2f0j"};